import React from "react"

export default ({ name, selector } = {}) => ({
  name,
  type: "line-height",
  component: ({ name: _name, value, onChange }) => {
    return (
      <div>
        <input type="number" value={value} step="0.1" onChange={onChange} />
      </div>
    )
  },
  css: value => {
    return `
      ${selector} {
        line-height: ${value};
      }
    `
  }
})
